import React from 'react'
import { useValues } from 'kea'
import { router } from 'kea-router'
import InviteStudent from './student'
import InviteTeacher from './teacher'

export default function Invite () {
  const {
    location: { pathname }
  } = useValues(router)
  return <div>{pathname === '/invite' ? <InviteTeacher /> : <InviteStudent />}</div>
}
